import React, { useState, useEffect, FormEvent, ChangeEvent } from 'react'

import axios from 'axios'
import { API_URL, config } from '../components/Include';
import { Alerts } from '../components/notify';

import { useParams } from 'react-router-dom'
const ChangePassword =()=> {
let param = useParams();

const [user, setUser] = useState({
email:'',
password:'',
confirmPassword:'',
})

const [errors, setErrors] = useState({
    email:'',
    message:'',
    password:'',
    is_loading:false,
    confirmPassword:'',
    successMessage:'',
    errorMessage:''

});

let myemail:any = param.email
let mytoken:any = param.token

const handleChange = (event:ChangeEvent<HTMLInputElement>)=>{
    let {name, value} = event.target;	

   setUser({...user, [name] : value });
   setErrors({...errors, [name]:''});
}



const handleSubmit =(event: FormEvent<HTMLFormElement>)=>{
    event.preventDefault();

    let error = {...errors}; 
    let formIsValid = true;

let msg ='This field is required';


if(!user.password){
error.password =msg;
formIsValid = false;
} 
if(!user.confirmPassword){
  error.confirmPassword =msg;
  formIsValid = false;
  } 

  if(user.confirmPassword.length <6){
    formIsValid = false;
    error.confirmPassword  ='Please enter minimum of 6 characters';
}


if(user.password!==user.confirmPassword){
  formIsValid = false;
  error.password ='Password does not match.';
}


if(!formIsValid){
setErrors(error) 
}

if(formIsValid) {
	setErrors({...errors, is_loading:true})
       
    const fd = new FormData();
    fd.append('email', myemail);
    fd.append('token', mytoken)
    fd.append('password', user.password);
       let url = API_URL+'/applicant/update_password';
axios.post(url, fd, config)
.then(response =>{
        if(response.data.status === 200){
          setErrors({...errors, successMessage: response.data.message, is_loading:false})
          
          setTimeout(() => {
            window.open('/', '_self')
           }, 3000);
  }else{
    setErrors({...errors, errorMessage: response.data.message, is_loading:false})
  }    
})
.catch((error)=>{
  setErrors({...errors, errorMessage: error.message, is_loading:false})

})

}
}




function verifyLink(){  
		    
      
  if(!myemail || !mytoken || myemail==='null'  || mytoken==='null' || mytoken==='' || myemail===''){
      window.open('/', '_self')
  
  }else{
    setErrors({...errors, is_loading:true})
     
        const fd = new FormData();
        fd.append('email', myemail)
        fd.append('token', mytoken)
  
        let url = API_URL+'/applicant_mail/verify_user';
        axios.post(url, fd, config)
        .then(response =>{
      
          if(response.data.status === 200){
        }else if (response.data.type ==='error'){
          Alerts('danger', response.data.message, 'Something went wrong!')
        
                setTimeout(() => {
                  window.open('/', '_self')
                 }, 2000);
        }    
      })
      .catch((error)=>{
        setErrors({...errors, errorMessage: error.message})

         setTimeout(() => {
          window.open('/', '_self')
         }, 2000);
      }).finally(()=>{
        setErrors({...errors, is_loading:false})
      })   
      } 
  }


useEffect(()=>{ 
    verifyLink() 
},[]); 

  return (
   

    <section className="choose-section pt-0" id="services"> 
   
    <div className="container"> 
 
 
 <div className="row float-center">
 
   <div className="col-md-6 my-5">
 
   {errors.successMessage?
 <div className="alert alert-secondary d-flex" role="alert">

   <i className="ri-error-warning-fill align-middle fs-27 me-2" aria-hidden="true"></i> 

   <p className="my-auto ">{errors.successMessage}</p> 

   <button type="button" className="close text-secondary ms-auto mb-auto" data-bs-dismiss="alert" aria-hidden="true"><i className="ri-close-line"></i></button> 
   
   </div>:''}
 <div className="card-group mb-0"> 
 
 
 <div className="card br-s-0 mb-0"> 
 
 {errors.is_loading?
  <div className='overlay' >
            <img src="/images/loader.svg" alt="loader" />
    </div> :''}

 <div className="card-body"> 
 
 <h2 className="text-medium text-dark ms-3 mt-3"> CHANGE PASSWORD</h2>
 
  <h6 className="fw-semibold  text-danger mb-4 ms-3">You must create a password that is at least 6 characters long and contains one letter, one number, or one symbol, and it must be unique.</h6> 
  
  
  <div className="panel tabs-style7 mt-2"> 
     
      <div className="panel-body p-0"> 

      <form onSubmit={handleSubmit}>

      <div className="tab-content mt-3"> 
      <div className="tab-pane active show" id="signinTab1" role="tabpanel"> <div className="card-body pt-0"> 
 

 
 <div className="form-group"> 
 <label  className="text-left form-label text-bold">Enter new password:</label> 
 
 <input type="password" name='password' value={user.password} onChange={handleChange} className={errors.password?"form-control form-control-lg border-danger ":"form-control form-control-lg"} placeholder="Password" role="presentation" autoComplete="off" required  /> 
 <span className='text-danger'>{errors.password}</span>
 </div> 
 
  
 <div className="form-group"> 
 <label  className="text-left form-label text-bold">Repeat new password:</label> 
 
 <input type="password" name='confirmPassword' value={user.confirmPassword} onChange={handleChange} className={errors.confirmPassword?"form-control form-control-lg border-danger ":"form-control form-control-lg"} placeholder="Password" role="presentation" autoComplete="off" required  /> 
 <span className='text-danger'>{errors.confirmPassword}</span>
 </div>


 <div className=""> 
 <button type="submit"  className="btn btn-primary btn-lg btn-block">Confirm Change</button> 
 </div>
 
 <div className="text-bold mt-3 "> Forget it, <a href="/" className="text-primary">send me back</a> to the sign in screen. </div>

  
  
  </div> 
  </div> 
  
 
 
  </div>
  </form>
  
   </div> </div> </div> </div> </div>
 
 
 
 
   </div>
 </div>
    
    
    </div>
    
     </section> 
  )
}

export default ChangePassword